module.exports = __webpack_public_path__ + "img/1568990007.bf0b4166.jpg";